import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M3.15 11.335c0-.986.771-2.063 2.415-2.938C7.175 7.541 9.449 6.985 12 6.985s4.826.555 6.435 1.412c1.644.875 2.415 1.952 2.415 2.938 0 .695-.401 1.452-1.276 2.17-.869.713-2.135 1.322-3.656 1.702a.75.75 0 1 0 .364 1.455c1.679-.42 3.163-1.111 4.244-1.998 1.075-.882 1.824-2.025 1.824-3.33 0-1.814-1.379-3.287-3.21-4.262-1.866-.993-4.391-1.588-7.14-1.588s-5.274.595-7.14 1.588c-1.831.975-3.21 2.448-3.21 4.262 0 1.688 1.196 3.064 2.823 4.011 1.362.793 3.13 1.355 5.106 1.615l-2.226 1.775a.75.75 0 1 0 .935 1.173l3.705-2.954a.75.75 0 0 0 .132-1.036L9.28 12.124a.75.75 0 0 0-1.2.9l1.851 2.47c-1.883-.229-3.512-.751-4.703-1.444-1.423-.828-2.077-1.803-2.077-2.714z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ArrowRotateIcon = ForwardRef;